<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData"></mainHead> -->
		<div class="pageTopBox space_between">
			<div class="titleText">渠道数据</div>
			<div class="addBtn flex_start">
				<el-button type="primary" plain icon="el-icon-download" size="small" @click="channelTempExport" v-hasPermi="['dataManage:channelIncome:import']">模版下载</el-button>
				<el-button type="primary" icon="el-icon-download" size="small" @click="channelExport" style="margin-right: 10px;"
				v-hasPermi="['dataManage:channelIncome:export']">导出</el-button>
				<!-- <el-popover placement="left" width="120" high="400" trigger="hover" class="el_popover">
					<el-upload class="upload-demo" ref='upload' action="#" :auto-upload="true" :show-file-list="false"
						:on-change="(file) => uploadFun(file, 'KS')" :http-request="uploadSet">
						<el-button type="primary" icon="el-icon-upload2" size="small">快手</el-button>
					</el-upload>
					<el-upload class="upload-demo" ref='upload' action="#" :auto-upload="true" :show-file-list="false"
						:on-change="(file) => uploadFun(file, 'BD')" :http-request="uploadSet">
						<el-button type="primary" icon="el-icon-upload2" size="small">百度</el-button>
					</el-upload>
					<el-upload class="upload-demo" ref='upload' action="#" :auto-upload="true" :show-file-list="false"
						:on-change="(file) => uploadFun(file, 'YLH')" :http-request="uploadSet">
						<el-button type="primary" icon="el-icon-upload2" size="small">广点通</el-button>
					</el-upload>
					<el-upload class="upload-demo" ref='upload' action="#" :auto-upload="true" :show-file-list="false"
						:on-change="(file) => uploadFun(file, 'CSJ')" :http-request="uploadSet">
						<el-button type="primary" icon="el-icon-upload2" size="small">穿山甲</el-button>
					</el-upload>
					<el-upload class="upload-demo" ref='upload' action="#" :auto-upload="true" :show-file-list="false"
						:on-change="(file) => uploadFun(file, 'SIGMOB')" :http-request="uploadSet">
						<el-button type="primary" icon="el-icon-upload2" size="small">sigmob</el-button>
					</el-upload>
					<el-button type="primary" icon="el-icon-upload2" size="small" slot="reference">导入</el-button>
				</el-popover> -->
				<el-upload class="upload-demo" ref='upload' action="#" :auto-upload="true" :show-file-list="false"
				v-hasPermi="['dataManage:channelIncome:import']"
					:on-change="(file) => uploadFun(file)" :http-request="uploadSet">
					<el-button type="primary" icon="el-icon-upload2" size="small">导入</el-button>
				</el-upload>
			</div>
		</div>
		<div class="mainPage" style="padding: 10px 24px 1px;">
			<div class="headTabs">
				<el-tabs v-model="activeTab" @tab-click="tabChange">
				  <el-tab-pane label="渠道维度" value="1" name="1"></el-tab-pane>
				  <el-tab-pane label="媒体维度" value="2" name="2"></el-tab-pane>
				</el-tabs>
			</div>
			<el-form inline class="el-form flex_start">
				<el-form-item label="日期" width="150">
					<el-date-picker v-model="datePicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size="small">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="渠道公司：" v-show="activeTab == 1">
					<el-input clearable size="small" style="width:210px" placeholder="请输入" v-model="queryData.channelCompany"></el-input>
				</el-form-item>
				<el-form-item label="媒体公司：" v-show="activeTab == 2">
					<el-input clearable size="small" style="width:210px" placeholder="请输入" v-model="queryData.mediaCompany"></el-input>
				</el-form-item>
				<el-form-item label="APP ID/名称：">
					<el-select v-model="queryData.appId" filterable clearable size="small" style="width:200px">
						<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="广告位：">
					<!-- <el-select v-model="queryData.adsId" clearable size="small" style="width:210px">
						<el-option v-for="item in mediaAdsOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select> -->
					<el-input clearable size="small" style="width:210px" placeholder="请输入" v-model="queryData.adsId"></el-input>
				</el-form-item>
				<el-form-item label="广告类型：">
					<el-select v-model="queryData.type" clearable size="small" style="width:180px">
						<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<div class="menu-right flex_start">
					<el-button @click="searchReset" size="small" v-hasPermi="['dataManage:channelIncome:query']">重置</el-button>
					<el-button type="primary" @click="confirmQuery" size="small" v-hasPermi="['dataManage:channelIncome:query']">查询</el-button>
					<!-- <i class="setLabel el-icon-setting"></i> -->
				</div>
			</el-form>
		</div>
		<div class="mainPage">
			<div class="tHeadRow flex_start">
				<div class="tHeadleftTips">查看维度</div>
				<el-checkbox-group v-model="tHeaderQueryChecked">
					<el-checkbox v-for="(item,index) in tHeaderQueryData" :label="item.value" size="mini"
						:checked="item.checked" :key="index" :name="item.value" @change="checkBoxQueryChange($event,item,index)">{{item.label}}
					</el-checkbox>
				</el-checkbox-group>
				<el-popover placement="left" width="400" high="400" trigger="click" class="el_popover" style="margin-left: auto;">
					<el-checkbox-group v-model="tHeaderColumnDataChecked" >
						<el-checkbox v-for="(columnObj,index) in tHeaderColumnData" :label="columnObj.label" size="mini"
							:checked="columnObj.checked" :key="columnObj.prop" :name="columnObj.prop" @change="checkBoxChange($event,columnObj,index)">{{columnObj.label}}
						</el-checkbox>
					</el-checkbox-group>
					<i class="setLabel el-icon-setting" slot="reference"></i>
				</el-popover>
			</div>
			
			<el-table key="table1" :max-height="560" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
				class="el_table" @sort-change="sortChangeFun" :header-cell-class-name="handleHeadAddClass" v-if="activeTab=='1'">
				<el-table-column prop="recordTime" label="日期" fixed width="120"></el-table-column>
				<el-table-column prop="companyName" label="渠道公司" fixed width="150"></el-table-column>
				<el-table-column prop="os" label="操作系统" fixed v-if="isShowOsTHead"></el-table-column>
				<el-table-column prop="mediaAppName" label="应用" fixed v-if="isShowAppTHead" width="150"></el-table-column>
				<el-table-column prop="type" label="广告类型" fixed v-if="isShowApptypeTHead" width="120"></el-table-column>
				<el-table-column prop="" label="渠道广告位" fixed v-if="isShowMediaAdIdTHead" width="200">
					<template slot-scope="scope">
						<div >{{scope.row.mediaAdName}}/{{scope.row.mediaAdId}}</div>
					</template>
				</el-table-column>
				<el-table-column v-for="(columnObj,index) in tHeaderColumnData" :key="index" v-if="columnObj.checked == true"
					:prop="columnObj.prop" :label="columnObj.label" :align="columnObj.align" :width="columnObj.width"
					:fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false">
					<template slot-scope="scope">
						<div v-if="scope.row[columnObj.prop] === null" style="color: #FF4D4F;">0</div>
						<div v-else>{{scope.row[columnObj.prop]}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="name" label="媒体请求成功"></el-table-column>
				<el-table-column prop="name" label="媒体成功率"></el-table-column>
				<el-table-column prop="name" label="媒体展示率"></el-table-column>
				<el-table-column prop="name" label="媒体填充率" width="150"></el-table-column>
				<el-table-column prop="name" label="媒体点击量" width="150"></el-table-column>
				<el-table-column prop="name" label="媒体点击率" width="150"></el-table-column>
				<el-table-column prop="name" label="媒体eCPM" width="150"></el-table-column>
				<el-table-column prop="name" label="渠道展现量" width="150"></el-table-column>
				<el-table-column prop="name" label="渠道展现差异率"></el-table-column>
				<el-table-column prop="name" label="渠道点击量"></el-table-column>
				<el-table-column prop="name" label="渠道点击差异率"></el-table-column>
				<el-table-column prop="name" label="渠道收益"></el-table-column>
				<el-table-column prop="name" label="媒体收益"></el-table-column>
				<el-table-column prop="name" label="收益误差"></el-table-column>
				<el-table-column prop="name" label="渠道eCPM"></el-table-column> -->
			</el-table>
			<el-table key="table2" :max-height="560" ref="tables" :header-cell-style="{color:'#333333',background:'#EAEFF5'}" :data="tableData"
				class="el_table" @expand-change="handleExpandChange" :row-class-name="tableRowClassName"
				@sort-change="sortChangeFun" :header-cell-class-name="handleHeadAddClass" v-if="activeTab=='2'">
				<!-- :expand-row-keys="expandedRows" -->
				<el-table-column type="expand" fixed="">
					<template slot-scope="props">
						<el-table :max-height="560" key="table3"
							:data="props.row.tabList" class="el_tables" :header-cell-style="{color:'#333333',background:'#F6FEFF'}">
							<el-table-column prop="recordTime" label="日期" fixed width="120">
								<template slot-scope="scope">
									<div>{{props.row.recordTime}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="companyName" label="渠道公司" fixed width="150"></el-table-column>
							<el-table-column prop="os" label="操作系统" fixed v-if="isShowOsTHead"></el-table-column>
							<el-table-column prop="mediaAppName" label="应用" fixed v-show="isShowAppTHead" width="150">
								<template slot-scope="scope">
									<div>{{props.row.mediaAppName}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="type" label="广告类型" fixed v-show="isShowApptypeTHead" width="120">
								<template slot-scope="scope">
									<div>{{props.row.mediaAppName}}</div>
								</template>
							</el-table-column>
							<el-table-column prop="" label="渠道广告位" fixed v-show="isShowMediaAdIdTHead" width="200">
								<template slot-scope="scope">
									<div >{{scope.row.mediaAdName}}/{{scope.row.mediaAdId}}</div>
								</template>
							</el-table-column>
							<el-table-column v-for="(columnObj,index) in tHeaderColumnData" :key="index" v-if="columnObj.checked == true"
								:prop="columnObj.prop" :label="columnObj.label" :align="columnObj.align" :width="columnObj.width"
								:fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false">
								<template slot-scope="scope">
									<div v-if="scope.row[columnObj.prop] === null" style="color: #FF4D4F;">0</div>
									<div v-else>{{scope.row[columnObj.prop]}}</div>
								</template>
							</el-table-column>
							<!-- <el-table-column prop="platAdsId" label="广告位渠道ID" width="180"></el-table-column>
							<el-table-column prop="reqNum" label="请求请求量"></el-table-column>
							<el-table-column prop="succNum" label="请求成功量"></el-table-column>
							<el-table-column prop="showNum" label="展示量"></el-table-column>
							<el-table-column prop="clickNum" label="点击量"></el-table-column>
							<el-table-column prop="bidPriceUnit" label="渠道收益" width="150"></el-table-column>
							<el-table-column prop="ecpmChannel" label="渠道eCPM" width="150"></el-table-column>
							<el-table-column prop="winPriceUnit" label="媒体收益" width="150"></el-table-column>
							<el-table-column prop="ecpmMedia" label="媒体eCPM" width="150"></el-table-column> -->
						</el-table>
					</template>
				</el-table-column>
				<el-table-column prop="recordTime" label="日期" fixed width="120"></el-table-column>
				<el-table-column prop="companyName" label="媒体公司" fixed width="150"></el-table-column>
				<el-table-column prop="os" label="操作系统" fixed v-if="isShowOsTHead"></el-table-column>
				<el-table-column prop="mediaAppName" label="应用" fixed v-if="isShowAppTHead" width="150"></el-table-column>
				<el-table-column prop="type" label="广告类型" fixed v-if="isShowApptypeTHead" width="120"></el-table-column>
				<el-table-column prop="" label="媒体广告位" fixed v-if="isShowMediaAdIdTHead" width="200">
					<template slot-scope="scope">
						<div >{{scope.row.mediaAdName}}/{{scope.row.mediaAdId}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="" label="所属应用/ID" width="200">
					<template slot-scope="scope">
						<div >{{scope.row.mediaAppName}}/{{scope.row.mediaAppId}}</div>
					</template>
				</el-table-column> -->
				<el-table-column v-for="(columnObj,index) in tHeaderColumnData" :key="index" v-if="columnObj.checked == true"
					:prop="columnObj.prop" :label="columnObj.label" :align="columnObj.align" :width="columnObj.width"
					:fixed="columnObj.fixed" :sortable="columnObj.sortable?'custom':false">
					<template slot-scope="scope">
						<div v-if="scope.row[columnObj.prop] === null" style="color: #FF4D4F;">0</div>
						<div v-else>{{scope.row[columnObj.prop]}}</div>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="reqNum" label="请求量"></el-table-column>
				<el-table-column prop="succNum" label="成功量"></el-table-column>
				<el-table-column prop="showNum" label="展示量"></el-table-column>
				<el-table-column prop="clickNum" label="点击量" width="150"></el-table-column>
				<el-table-column prop="bidPriceUnit" label="渠道收益" width="150"></el-table-column>
				<el-table-column prop="ecpmChannel" label="渠道eCPM" width="150"></el-table-column>
				<el-table-column prop="winPriceUnit" label="媒体收益" width="150"></el-table-column>
				<el-table-column prop="ecpmMedia" label="媒体eCPM" width="150"></el-table-column> -->
			</el-table>
			<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
				<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</div>
		</div>
		<!-- <el-dialog title="媒体信息" :visible.sync="dialogVisible"
		  width="30%">
		  <span>这是一段信息</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
		  </span>
		</el-dialog> -->
		<el-drawer @close="closeDrawer" :visible.sync="companyDrawerShow" size="48%" :wrapperClosable="true"
			:with-header="false">
			<el-card class="box-card">
				<div slot="header" class="cardTitle space_between">
					<div class="cardTitleTxt">公司信息</div>
					<i class="el-icon-circle-close" @click="companyDrawerShow=false"></i>
				</div>
				<el-form inline class="el-form" label-width="120px" :rules="rulesApi" :model="companyFormData"
					ref="ruleCompanyForm">
					<el-form-item label="公司简称：" prop="nickName">
						<el-input clearable size="small" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="公司全称：" prop="companyName">
						<el-input clearable size="small" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="公司地址：">
						<el-input clearable size="small" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="联系人：">
						<el-input clearable size="small" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="联系方式：">
						<el-input clearable size="small" placeholder="请输入"></el-input>
					</el-form-item>
					<el-form-item label="合作情况：">
						<el-select v-model="queryData.syncStatus" clearable size="small">
							<el-option label="跟进中" :value="1"></el-option>
							<el-option label="合作中" :value="2"></el-option>
							<el-option label="合作结束" :value="3"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="回调地址：">
						<el-input clearable size="small" placeholder="请输入"></el-input>
					</el-form-item>
					<div class="card-bottom flex_end">
						<el-button @click="companyDrawerShow=false" size="medium">取消</el-button>
						<el-button type="primary" @click="confirmCompany('ruleCompanyForm')" size="medium">确定</el-button>
					</div>
				</el-form>
			</el-card>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				mainHeadTitle: '媒体管理',
				companyDrawerShow: false,
				handleSelection: "", // 存储ID
				datePicker: [],
				adTypeSelectData: [],
				adTypeOptions: [], // 广告类型下拉选择
				mediaAdsOptions: [], //广告位下拉选择
				queryData: {
					channelCompany: ''
				},
				mediaAppOptions: [], // 媒体APP下拉选择列表
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				rulesApi: {
					companyName: [ //公司名称
						{
							required: true,
							message: '必填项，请输入',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 50,
							message: '长度在 1 到 50 个字符',
							trigger: 'blur'
						}
					],
					nickName: [ //公司地址
						{
							required: true,
							message: '请输入公司简称',
							trigger: 'blur'
						},
					],
				},
				companyFormData: {},
				channelTableDatas: [],
				dialogVisible: false, // 弹框显隐
				tHeaderColumnDataChecked: [],
				tHeaderColumnDataOption: [],
				tHeaderColumnDataShow: [],
				tHeaderQueryChecked: ['1','2','3','4'],
				tHeaderQueryData: [
					{value: '1',label: "操作系统",checked: false},
					{value: '2',label: "应用",checked: false},
					{value: '3',label: "广告类型",checked: false},
					{value: '4',label: "广告单元",checked: false},
				],

				expandedRows: [], // 记录展开的行
				// 表头数据存放
				tHeaderColumnData: [
					{
						prop: 'succNum',
						label: "媒体请求成功",
						checked: false,
						sortable: true,
						width: '150',
					},
					{
						prop: 'succReqRate',
						label: "媒体成功率",
						checked: false,
						sortable: false,
					},
					{
						prop: 'showNum',
						label: "媒体展示量",
						checked: true,
						sortable: true,
						width: '150',
					},
					{
						prop: 'succShowRate',
						label: "媒体展示率",
						checked: true,
						sortable: false,
					},
					// {
					// 	prop: 'fillRates',
					// 	label: "媒体填充量",
					// 	checked: false,
					// 	sortable: false,
					// },
					{
						prop: 'fillRate',
						label: "媒体竞得率",
						checked: false,
						sortable: false,
					},
					{
						prop: 'clickNum',
						label: "媒体点击量",
						checked: true,
						sortable: true,
						width: '150',
					},
					{
						prop: 'clickRate',
						label: "媒体点击率",
						checked: false,
						sortable: false,
					},
					{
						prop: 'ecpmMedia',
						label: "媒体eCPM",
						checked: false,
						sortable: false,
						width: '150',
					},
					{
						prop: 'platShowNum',
						label: "渠道展现量",
						checked: false,
						sortable: false,
						width: '150',
					},
					{
						prop: 'showDiffRate',
						label: "渠道展现差异率",
						checked: true,
						sortable: false,
						width: '180',
					},
					{
						prop: 'platClickNum',
						label: "渠道点击量",
						checked: true,
						sortable: false,
						width: '150',
					},
					{
						prop: 'clickDiffRate',
						label: "渠道点击差异率",
						checked: true,
						sortable: false,
						width: '180',
					},
					{
						prop: 'estimateProfit',
						label: "渠道收益",
						checked: false,
						sortable: false,
						width: '150',
					},
					{
						prop: 'winPriceUnit',
						label: "媒体收益",
						checked: false,
						sortable: false,
						width: '150',
					},
					{
						prop: 'profitDiff',
						label: "收益误差",
						checked: true,
						sortable: false,
					},
					{
						prop: 'ecpm',
						label: "渠道eCPM",
						checked: true,
						sortable: false,
					},
				],
				sortField: {},
				orderBys: [],
				activeTab: '1',
				
				tableDatas: [],
				isShowOsTHead: true,
				isShowAppTHead: true,
				isShowApptypeTHead: true,
				isShowMediaAdIdTHead: true,
			}
		},
		mounted() {
			if(localStorage.getItem('channelThead')){
				this.tHeaderColumnDataChecked = JSON.parse(localStorage.getItem('channelThead'))
				let checked = false
				this.tHeaderColumnData.forEach((item,index)=>{
					checked = this.tHeaderColumnDataChecked.some((items) => items === item.label)
					if(checked){
						item.checked = true
					}else{
						item.checked = false
					}
				})
			}
			this.dateInit();
			this.getMediaAppOption();
			this.getADTypeOption();
			// this.tHeaderColumnData.forEach(item => {
			// 	if(item.checked == true){
			// 		this.tHeaderColumnDataShow.push(item)
			// 	}
			// })
			// this.tHeaderColumnDataChecked = this.tHeaderColumnData.slice(0,6)
			// this.getMediaAdsOption();
			this.getTableData();
		},
		methods: {
			// 日期选择器初始化
			dateInit() {
				this.datePicker = []
				let currentDate = new Date();
				let year = currentDate.getFullYear();
				let month = String(currentDate.getMonth() + 1).padStart(2, '0');
				let day = String(currentDate.getDate()).padStart(2, '0');
				let formattedDate = `${year}-${month}-${day}`;
				this.datePicker.push(formattedDate);
				this.datePicker.push(formattedDate);
			},
			// 获取媒体APP下拉列表
			async getMediaAppOption() {
				let res = await this.$http.get(this.$api.common.mediaAppOption);
				this.mediaAppOptions = res.data
			},
			// 获取表头数据
			async tHeaderColumnInit() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize
				}
				let res = await this.$http.post(this.$api.companyList, data);
				// this.tHeaderColumnDataOption = res.data
			},
			// 获取广告类型下拉列表
			async getADTypeOption() {
				let res = await this.$http.get(this.$api.common.adTypeOption);
				this.adTypeOptions = res.data
			},
			// 获取广告位下拉列表
			async getMediaAdsOption(){
				let res = await this.$http.get(this.$api.common.mediaAdsOption);
				this.mediaAdsOptions = res.data
			},
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				data['groupByType'] = this.tHeaderQueryChecked
				if (this.datePicker && this.datePicker.length>0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data['findGroup'] = this.activeTab
				data = {...data,...this.queryData}
				// console.log(JSON.stringify(data))
				let res = await this.$http.post(this.$api.dataManage.channelDataList, data);
				if(res.code == 1){
					this.tableData = res.data.list
					this.total = res.data.totalRecord
				}
			},
			// 获取二级表格列表
			async getAppDataSecList(adsId,time,index){
				// console.log(index)
				let data = {
					adsId: adsId,
					recordTime: time
				}
				let res = await this.$http.get(this.$api.dataManage.mediaDetailList, data);
				this.tableData[index].tabList = res.data
				for(let i=0;i<this.tableData.length;i++){
					for(let j=0;j<this.expandedRows.length;j++){
						if(this.expandedRows[j].mediaAdId == this.tableData[i].mediaAdId&&this.expandedRows[j].recordTime == this.tableData[i].recordTime){
							this.expandedRows.splice(j,1,this.tableData[i])
						}
					}
				}
				this.$forceUpdate();
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			addTableData() {
				this.companyFormData = {}
				this.companyDrawerShow = true
			},
			editTable(row, index) {
				row['editShow'] = true
				this.$set(this.tableData, index, row)
			},
			editConfirm(row, index) {
				row['editShow'] = false
				this.$set(this.tableData, index, row)
			},
			closeDrawer() {
				this.companyDrawerShow = false
			},
			confirmCompany(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = this.companyFormData;
						let res = await this.$http.post(this.$api.companyList, data);
						this.$message.success('编辑成功');
						this.closeDrawer();
						this.getTableData();
					}
				});
			},
			mediaManage() {

			},
			// 阻止默认上传
			uploadSet(){},
			// 导入
			async uploadFun(file,type) {
				// console.log(file)
				// console.log(type)
				// const fileExtension = file.name.split(".").pop().toLowerCase(); // 获取文件后缀名
				// const isTypeOk = this.fileType.includes(fileExtension);
				// if (!isTypeOk) {
				// 	return false; // 阻止文件上传并移除
				// }
				// 上传
				let formdata = new FormData();
				formdata.append("file", file.raw);
				// formdata.append("platId", type);
				let res = await this.$http.post(this.$api.dataManage.appImport, formdata);
				if(res.code == 1){
					this.$message.success('导入成功');
				}
			},
			// 导出
			async channelExport() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					startToday: '',
					endToday: '',
				}
				data['groupByType'] = this.tHeaderQueryChecked
				if (this.datePicker && this.datePicker.length > 0) {
					data.startToday = this.datePicker[0];
					data.endToday = this.datePicker[1];
				}
				data['findGroup'] = this.activeTab
				this.queryData['adOrderByReqs'] = this.orderBys
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.dataManage.channelExport, data, 1);
				const time = this.getTimeFun();
				this.$http.downloads(res,`${time}渠道数据.xls`)
			},
			// 模版下载
			async channelTempExport(){
				let data = {}
				let res = await this.$http.get(this.$api.dataManage.templateDownload);
				if(res.code == 1){
					let a = document.createElement('a')
					a.href = res.data
					a.click();
				}
				// const time = this.getTimeFun();
				// this.$http.downloads(res,`${time}渠道收入模版.xls`)
			},
			// 下载选择的日期
			getTimeFun() {
				if (!this.datePicker || !this.datePicker.length) {
					return ''
				}
				var startMonth = this.datePicker[0];
				var endMonth = this.datePicker[1];
				// 如果开始时间和结束时间相同，则以开始时间为主
				if (startMonth === endMonth) {
					endMonth = ''
				};
				return startMonth + "-" + endMonth;
			},
			// 复选框
			handleSelectionChange(val) {
				this.handleSelection = val.map(res => {
					return {
						"reviewReduce": res.cut,
						"id": res.id
					}
				})
			},
			// 复选框控制
			checkSelectable(row, index) {
				// console.log(row.rstate);
				return true
			},

			tHeaderColumnShow() {

			},
			// 表头多选框
			checkBoxChange(e,item,index){
				// if(e == true){
				// 	this.tHeaderColumnDataShow.push(item)
				// }else{
				// 	let delIndex = 0
				// 	this.tHeaderColumnDataShow.forEach((items,indexs) => {
				// 		if(items.label==item.label){
				// 			delIndex = indexs
				// 		}
				// 	})
				// 	this.tHeaderColumnDataShow.splice(delIndex,1)
				// }
				this.tHeaderColumnData[index].checked = e
				localStorage.setItem('channelThead',JSON.stringify(this.tHeaderColumnDataChecked))
				// console.log(this.tHeaderColumnDataChecked)
				this.$forceUpdate();
			},
			checkBoxQueryChange(e,item,index){
				// console.log(this.tHeaderQueryChecked);
				this.tHeaderQueryData[index].checked = e
				if(this.tHeaderQueryChecked.some(item=>item=='1')){
					this.isShowOsTHead = true
				}else{
					this.isShowOsTHead = false
				}
				if(index == 1){
					this.isShowAppTHead = e
				}
				if(index == 2){
					this.isShowApptypeTHead = e
				}
				if(index == 3){
					this.isShowMediaAdIdTHead = e
				}
				this.currentPage = 1
				this.getTableData();
			},
			// 表头高亮保持
			handleHeadAddClass({
				column
			}) {
				// console.log(column)
				if (this.sortField[column.property]) {
					column.order = this.sortField[column.property]
				}
			},
			// 排序监听
			sortChangeFun({
				column,
				prop,
				order
			}) {
				// 触发的排序和缓存的排序相同时，取消该字段的排序
				if (!order || this.sortField[prop] === order) {
					this.sortField[prop] = null
				} else {
					this.sortField[prop] = order
				}
				this.orderBys = []
				let direction = ''
				for (const i in this.sortField) {
					if (this.sortField[i]) {
						if (this.sortField[i] == 'ascending') {
							direction = 'ASC'
						} else if (this.sortField[i] == 'descending') {
							direction = 'DESC'
						}
						this.orderBys.push({
							"orderField": i,
							"orderType": direction
						})
					}
				}
				this.currentPage = 1
				this.queryData['adOrderByReqs'] = this.orderBys
				this.getTableData() //调用后端查询接口
			},
			// 表格展开方法
			handleExpandChange(row, expanded) {
				this.expandedRows = expanded
				const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.mediaAdId === row.mediaAdId&&expandedRow.recordTime === row.recordTime);
				if(isExpanded){
					this.tableData.forEach((item,index) => {
						if(row.mediaAdId == item.mediaAdId&&row.recordTime == item.recordTime){
							this.getAppDataSecList(row.mediaAdId,row.recordTime,index);
						}
					})
				}
			},
			tableRowClassName({row}) {
				// 判断当前行是否在 expandedRows 列表中
				const isExpanded = this.expandedRows.some((expandedRow) => expandedRow.mediaAdId === row.mediaAdId&&expandedRow.recordTime === row.recordTime);
				return isExpanded ? 'success-row' : ''; // 如果在展开列表中，则添加类，否则清除类
			},
			tabChange(tab,event){
				this.currentPage = 1
				this.total = 0
				this.queryData['appId'] = ''
				this.queryData['channelCompany'] = ''
				// console.log(this.total)
				this.getTableData()
			}
		},
	}
</script>

<style scoped>
	.mainPage {
		margin: 20px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 16px 24px;
	}
	.headTabs{
		margin-bottom: 10px;
	}
	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}
	.tHeadRow{
		align-items: center;
	}
	.tHeadleftTips{
		font-size: 12px;
		margin-bottom: 10px;
		margin-right: 15px;
	}

	.menu-right {
		margin-left: auto;
		margin-bottom: 20px;
		align-items: center;
	}

	.setLabel {
		margin-left: 10px;
		font-size: 30px;
		cursor: pointer;
	}

	.cardTitle {
		font-weight: 500;
		font-size: 22px;
		color: #000000;
	}

	.cardTitle i {
		cursor: pointer;
	}

	.cardTitleTxt {
		font-size: 16px;
	}

	.box-card {
		height: 100%;
	}

	.box-card /deep/ .el-form--inline .el-form-item {
		display: block !important;
	}

	.card-bottom {
		padding-right: 30px;
	}




	.pageTopBox {
		height: 54px;
		width: 100%;
		/* border-left: 3px solid #4568dc; */
		box-shadow: 0 3px 15px rgb(0 0 0 / 5%);
		padding: 0 20px;
		box-sizing: border-box;
		background: #FFFFFF;
		align-items: center;
	}

	.addBtn {
		padding-right: 5px;
	}

	.titleText {
		font-family: PingFang SC, PingFang SC;
		line-height: 54px;
		font-weight: 500;
		font-size: 18px;
		color: #333333;
	}

	.crumbsText {
		margin-left: auto;
		font-size: 14px;
		line-height: 54px;
		cursor: pointer;
		color: #4568dc;
	}

	.crumbsText span {
		color: #6c757d;
		cursor: auto;
	}

	/deep/.success-row {
		background-color: #EBFAFF !important;
	}

	.el_tables {
		background-color: #F6FEFF;
		font-size: 12px !important;
	}
	.el_tables /deep/ tr{
		background-color: #F6FEFF !important;
	}
	.el_table /deep/.el-table__expanded-cell{
		padding: 0 !important;
		padding-left: 48px !important;
		background: rgb(246, 254, 255) !important;
	}
	.el-checkbox-group{
		padding: 10px !important;
	}
	.el-checkbox{
		margin-bottom: 10px;
	}
	/deep/ .el-table__expanded-cell{
		padding-right: 0;
		padding-left: 40px;
	}
	
	
	.upload-demo{
		/* margin: 0 auto; */
		/* margin-bottom: 10px; */
	}
</style>